import { defineAsyncComponent } from "vue";
export default function (path, withDefineAsyncComponent = false) {
  let promiseFactory = () => {
    return new Promise((resolve) => {
      if (!path) {
        resolve(false);
        return;
      }

      const overridePath = `@/overrides/client/${path}`;

      // try app‑specific → override → core
      import(/* webpackPrefetch: true */ `@/client/applications/${process.env.VUE_APP_APPLICATION_NAME}/${path}`)
        .catch(() =>
          import(/* webpackPrefetch: true */ `${overridePath}`)
            .catch(() =>
              import(/* webpackPrefetch: true */ `@/client/${path}`)
            )
        )
        .then((result) => resolve(result))
        .catch(() => resolve(false)); // all attempts failed
    });
  };


  if (withDefineAsyncComponent) {
    return defineAsyncComponent(promiseFactory);
  } else {
    return promiseFactory;
  }
}
